module.exports = __webpack_public_path__ + "img/img-93.5bb12420.png";